// import React, { useCallback, useEffect, useRef, useState } from "react";
// import Breadcrump from "../../components/Breadcrump";
// import categoryAPI from "../../api/categoryApi";
// import CategoryCard from "../categories/Card";

// function ListPage() {
//   const [items, setItems] = useState([]);
//   const [totalCount, setTotalCount] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const observer = useRef();

//   useEffect(() => {
//     fetchCategories(page);
//   }, [page]);

//   const fetchCategories = async (currentPage) => {
//     setLoading(true);

//     try {
//       const res = await categoryAPI.listing({ page: currentPage });

//       if (res.code === 200) {
//         const { items, pagination } = res.data;

//         setItems((prev) =>
//           currentPage === 1 ? items || [] : [...prev, ...(items || [])],
//         );
//         setTotalCount(pagination?.totalCount || 0);
//       }
//     } catch (err) {
//       console.error("Error loading categories:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const lastItemRef = useCallback(
//     (node) => {
//       if (loading) return;

//       if (observer.current) observer.current.disconnect();

//       observer.current = new IntersectionObserver((entries) => {
//         if (entries[0].isIntersecting && items.length < totalCount) {
//           setPage((prev) => prev + 1);
//         }
//       });

//       if (node) observer.current.observe(node);
//     },
//     [loading, items, totalCount],
//   );

//   return (
//     <>
//       <Breadcrump title="Category" />

//       <section className="s-term-user flat-spacing-25">
//         <div className="container">
//           {items && items.length > 0 && (
//             <>
//               <div className="blog-count text-left mb-4">
//                 Total: <b>{totalCount}</b> categories
//               </div>

//               <div className="row g-3 mt-2">
//                 {items.map((item, index) => {
//                   if (index === items.length - 1) {
//                     return (
//                       <div
//                         className="col-lg-3 col-12 col-sm-6"
//                         key={item._id || item.id}
//                         ref={lastItemRef}
//                       >
//                         <CategoryCard item={item} />
//                       </div>
//                     );
//                   }

//                   return (
//                     <div className="col-lg-3 col-12   col-sm-6" key={item._id || item.id}>
//                       <CategoryCard item={item} />
//                     </div>
//                   );
//                 })}
//               </div>
//             </>
//           )}

//           {loading && (
//             <div className="text-center mt-4">
//               <p>Loading more products...</p>
//             </div>
//           )}

//           {/* End Message */}
//           {!loading && items.length >= totalCount && (
//             <div className="text-center mt-4">
//               <p>✨ You’ve reached the end</p>
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// }

// export default ListPage;




import React, { useCallback, useEffect, useRef, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import categoryAPI from "../../api/categoryApi";
import CategoryCard from "../categories/Card";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const observer = useRef();

  useEffect(() => {
    fetchCategories(page);
  }, [page]);

  const fetchCategories = async (currentPage) => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing({ page: currentPage });

      if (res.code === 200) {
        const { items, pagination } = res.data;

        setItems((prev) =>
          currentPage === 1 ? items || [] : [...prev, ...(items || [])],
        );
        setTotalCount(pagination?.totalCount || 0);
      }
    } catch (err) {
      console.error("Error loading categories:", err);
    } finally {
      setLoading(false);
    }
  };

  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && items.length < totalCount) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, items, totalCount],
  );

  return (
    <div className="min-h-screen bg-[var(--color-bg)] font-[var(--font-body)] text-[var(--color-text)] transition-colors duration-300">
      <Breadcrump title="Category" />

      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div>
          {items && items.length > 0 && (
            <>
              {/* Animated Header Count */}
              <div className="flex items-center justify-between mb-8 pb-4 border-b border-[var(--color-border)] animate-fade-in">
                <p className="text-[var(--color-text-muted)] text-sm sm:text-base tracking-wide uppercase font-medium">
                  Explore Collections
                </p>
                <div className="bg-[var(--color-bg-alt)] px-4 py-2 rounded-full border border-[var(--color-border)] shadow-xs transition-transform hover:scale-105 duration-300">
                  <span className="text-[var(--color-text-muted)] text-sm">Total: </span>
                  <b className="text-[var(--color-primary)] font-bold">{totalCount}</b>
                  <span className="text-[var(--color-text-muted)] text-sm"> categories</span>
                </div>
              </div>

              {/* Grid layout with unique stagger and hover card animations */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {items.map((item, index) => {
                  const isLast = index === items.length - 1;
                  return (
                    <div
                      key={item._id || item.id}
                      ref={isLast ? lastItemRef : null}
                      className="transform transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(74,47,30,0.15)] rounded-xl overflow-hidden bg-[var(--color-white)] border border-[var(--color-border)] animate-fade-in-up"
                      style={{ animationDelay: `${(index % 4) * 0.1}s` }}
                    >
                      <CategoryCard item={item} />
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {/* Unique Pulsing Loader */}
          {loading && (
            <div className="flex flex-col items-center justify-center py-12 space-y-3">
              <div className="w-10 h-10 border-4 border-[var(--color-border)] border-t-[var(--color-primary)] rounded-full animate-spin"></div>
              <p className="text-[var(--color-text-muted)] text-sm font-medium animate-pulse">
                Loading more categories...
              </p>
            </div>
          )}

          {/* Unique End Message */}
          {!loading && items.length > 0 && items.length >= totalCount && (
            <div className="text-center py-12">
              <div className="inline-block px-6 py-3 bg-[var(--color-bg-alt)] border border-[var(--color-border)] rounded-full shadow-xs text-[var(--color-primary)] font-medium tracking-wide animate-bounce">
                ✨ You’ve reached the end of the collection
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default ListPage;
